import { autoinject } from "aurelia-framework";

/**
 * Custom element that provides a list layout for its child elements.
 */
@autoinject
export class ListLayoutCustomElement
{
}
